import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';

import { ProfileTemplateScopeTypeSchema } from './shared.schemas.js';

export const ListProfileTemplatesQuerySchema = PaginationSchema.extend({
  active: z
    .enum(['true', 'false'])
    .optional()
    .transform((value) => (value === undefined ? undefined : value === 'true')),
  q: z.string().optional(),
  scopeType: ProfileTemplateScopeTypeSchema.optional(),
});

export type ListProfileTemplatesQuery = z.infer<typeof ListProfileTemplatesQuerySchema>;

export const ProfileTemplateListItemSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  scopeType: ProfileTemplateScopeTypeSchema,
  active: z.boolean(),
  permissionCount: z.number().int().nonnegative(),
  createdAt: z.string(),
});

export type ProfileTemplateListItem = z.infer<typeof ProfileTemplateListItemSchema>;

export const ListProfileTemplatesResponseSchema = z.object({
  items: z.array(ProfileTemplateListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListProfileTemplatesResponse = z.infer<typeof ListProfileTemplatesResponseSchema>;
